module.exports = __webpack_public_path__ + "img/wechat-menu-head.b06f2d50.png";